import { createSlice } from "@reduxjs/toolkit";
import { getAllvisions } from "../actions/visionMession.actions";

const initialState = {
  visions: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const visionsMessionsSlice = createSlice({
  name: "visions",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllvisions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllvisions.fulfilled, (state, action) => {
        state.visions = action.payload;
        state.loading = false;
      })
      .addCase(getAllvisions.rejected, (state, action) => {
        state.visions = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default visionsMessionsSlice.reducer;
